<div [ngClass]="field.is_half ? 'mb-3 half-field': 'mb-3 full-field'" *ngIf="eventValues">
  <div *ngIf="field.id != 'space'">
    <label [for]="field.id" class="form-label" [ngClass]="{'required': field.required}">
      {{field.label}}
    </label>
    <input *ngIf="field.type === 'text'" type="text" class="form-control" bkInput [id]="field.id" [name]="field.id"
      [(ngModel)]="eventValues[field.id]" [required]="field.required">
    <input *ngIf="field.type === 'date'" type="text" class="form-control datetimepicker" bkInput [id]="field.id"
      autocomplete="off" bsDatepicker [bsValue]="getDateValue()" (bsValueChange)="onDateChange($event)"
      [required]="field.required">
    <input *ngIf="field.type === 'date'" type="hidden" [name]="field.id" [(ngModel)]="eventValues[field.id]"
      [required]="field.required">
    <input *ngIf="field.type === 'checkbox'" type="checkbox" class="ms-2 form-check-input" [id]="field.id"
      [name]="field.id" [(ngModel)]="eventValues[field.id]">
    <ng-select *ngIf="field.type === 'dropdown'" [items]="lists[field.list_name]" bindLabel="label" bindValue="value"
      [multiple]="field.multiple" [id]="field.id" [name]="field.id" [(ngModel)]="eventValues[field.id]"
      [required]="field.required"></ng-select>
    <div *ngIf="field.type === 'duration'" class="d-flex align-items-center duration-field">
      <ng-select class="duration-select" [items]="durationOptions" [clearable]="false" [id]="field.id"
        [name]="field.id" [(ngModel)]="eventValues[field.id]" [required]="field.required"></ng-select>
      <span class="ms-2">Day(s)</span>
    </div>
    <div *ngIf="field.type === 'amount'" class="input-group amount-field">
      <span class="input-group-text">$</span>
      <input type="text" class="form-control" bkInput [id]="field.id" [name]="field.id" size="10" inputmode="decimal"
        pattern="[0-9]*\.?[0-9]*" [ngModel]="eventValues[field.id]" (ngModelChange)="onAmountChange($event)"
        [required]="field.required">
    </div>
  </div>
</div>
<div *ngIf="!eventValues" [ngClass]="field.is_half ? 'mb-3 half-field': 'mb-3 full-field'">
  <label [for]="field.id" class="form-label"> {{ field.id != 'space' ? field.label : ''}}</label>
  <input *ngIf="field.type === 'text' && field.id != 'space'" type="text" class="form-control" bkInput [id]="field.id">
  <input *ngIf="field.type === 'text' && field.id == 'space' && isVisibleSpace " type="text" class="form-control" bkInput
    [id]="field.id" value="S P A C E" disabled>
  <input *ngIf="field.type === 'date'" type="text" class="form-control datetimepicker" bkInput [id]="field.id"
    autocomplete="off" bsDatepicker>
  <input *ngIf="field.type === 'checkbox'" type="checkbox" class="ms-2 form-check-input" [id]="field.id">
  <ng-select *ngIf="field.type === 'dropdown'" [items]="lists[field.list_name]" [multiple]="field.multiple"
    [id]="field.id"></ng-select>
</div>